Namespace 'Monitoring.Reports.Publications.Sections'

class Monitoring.Reports.Publications.Sections.PageFansView extends Backbone.View

  tagName: 'section'
  template: JST['backbone/templates/monitoring/reports/publications/section']

  initialize: (@options = {}, @header = {}) ->
    # just set @options

  render_twitter:->
    @$el.html(@template({title: @options.title}))
    return this
    
  render: ->
    @$el.html(@template({title: @options.title}))
    return this

  to_utcdate: (string_dates)->
    res= []
    for date in string_dates
      aux = date[0].split("-")
      year = parseInt(aux[0])
      month = parseInt(aux[1]) - 1
      day = parseInt(aux[2])
      res.push( [Date.UTC(year, month,day), date[1] ])
    res
    
  fill_twitter_page_analytics: (data) ->
    fans_data = _.map [0], (i) =>
      name = I18n.t("monitoring.dashboard.publications.sections.page.#{data[i][0]}")
      value = @to_utcdate(data[i][1])
      { name: name, data: value }
    if @header.include_page_fans_evolution()
      fans_title = I18n.t('monitoring.dashboard.publications.sections.user_followers_chart_title')
      fans_chart_view = new Monitoring.Reports.Publications.Subsections.ChartView(fans_data, fans_title)
      @$el.find('.container').append(fans_chart_view.render().el)

  fill_page_analytics: (data) ->
    fans_data = _.map [4, 5, 6], (i) =>
      name = I18n.t("monitoring.dashboard.publications.sections.page.#{data[i][0]}")
      value = @to_utcdate(data[i][1])
      { name: name, data: value }
    if @header.include_page_fans_evolution()
      fans_title = I18n.t('monitoring.dashboard.publications.sections.page_fans_chart_title')
      fans_chart_view = new Monitoring.Reports.Publications.Subsections.ChartView(fans_data, fans_title)
      @$el.find('.container').append(fans_chart_view.render().el)